export default __webpack_public_path__ + "static/media/3536 cutlery top.a39de185.png";